/* F24 · Las horas que la actividad sugiere. Lo usan el Inicio y el timesheet:
   la misma lista, el mismo botón. Sugiere, nunca imputa — cargar es un clic
   con el nombre de la persona, y «no» se recuerda para no volver a preguntar. */
import { api, ApiError, type SugerenciaHoras } from "../api";
import { esc, Fechas, toast, modal } from "../ui";

const minutosH = (m: number) => (m >= 60 ? Math.floor(m / 60) + " h" + (m % 60 ? " " + (m % 60) + " min" : "") : m + " min");

export function sugerenciasHtml(ss: SugerenciaHoras[], o: { titulo?: string } = {}): string {
  if (!ss.length) return "";
  return '<div class="card" style="border-color:var(--accentBorder)"><div class="cab" style="background:var(--accentTint)"><div class="t">' + esc(o.titulo ?? "Horas que faltan por cargar, según tu actividad") + '</div>' +
    '<span style="font-size:12px;color:var(--text3)">estuviste dentro de estos jobs más de 30 minutos y no lo has cargado · sugiere, no imputa</span></div>' +
    ss.map((s) => '<div class="sugerencia" data-sug="' + s.jobId + "|" + s.dia + '"><span class="dot" style="background:' + esc(s.cliente.color) + '"></span>' +
      '<div style="flex-grow:1;min-width:0"><div class="t">' + esc(s.job) + ' <span style="font-weight:500;color:var(--text3)">· ' + esc(s.cliente.nombre) + "</span></div>" +
      '<div class="m">' + esc(Fechas.dia(s.dia)) + " · " + minutosH(s.minutos) + " dentro del job" + (s.horasImputadas ? " · ya cargaste " + s.horasImputadas + " h" : "") + "</div></div>" +
      '<button class="btn chico fantasma" data-sug-no="' + s.jobId + '" data-dia="' + s.dia + '" title="No fue trabajo, o ya está en otro sitio. No se vuelve a preguntar.">No</button>' +
      '<button class="btn chico primario" data-sug-si="' + s.jobId + '" data-dia="' + s.dia + '" data-h="' + s.horasSugeridas + '">Cargar ' + s.horasSugeridas + " h</button></div>").join("") + "</div>";
}

/** Enlaza cargar y descartar; `alCambiar` repinta. */
export function montarSugerencias(root: HTMLElement, alCambiar: () => void) {
  root.querySelectorAll<HTMLButtonElement>("[data-sug-si]").forEach((b) => b.onclick = async () => {
    b.disabled = true;
    const body = { jobId: b.dataset.sugSi!, fecha: b.dataset.dia!, horas: Number(b.dataset.h), nota: "Sugerido por tu actividad en el job" };
    try {
      await api.imputar(body);
      toast("<b>" + b.dataset.h + " h cargadas.</b> Valoradas al costo del rol vigente.");
      alCambiar();
    } catch (e) {
      const err = e as ApiError;
      // Feriado o job cerrado: la misma pregunta que hace el botón flotante.
      // Se estuvo dentro del job ese día, así que casi nunca es error de fecha.
      if (err.codigo === "dia_no_laborable" || err.codigo === "job_cerrado") {
        modal({ titulo: err.codigo === "dia_no_laborable" ? "Día no laborable" : "Job cerrado", sub: (err.mensaje || "") + " Tu actividad dice que estuviste dentro del job ese día.",
          botones: [{ t: "Dejarlo", fn: () => { b.disabled = false; } }, { t: "Cargar de todas formas", cls: "primario", fn: async () => { await api.imputar({ ...body, forzar: true }); toast("<b>" + b.dataset.h + " h cargadas.</b>"); alCambiar(); } }] });
        return;
      }
      b.disabled = false; toast("<b>No se pudo cargar.</b> " + esc(err.mensaje ?? err.message));
    }
  });
  root.querySelectorAll<HTMLButtonElement>("[data-sug-no]").forEach((b) => b.onclick = async () => {
    b.disabled = true;
    try { await api.descartarSugerencia(b.dataset.sugNo!, b.dataset.dia!); b.closest(".sugerencia")?.remove(); toast("Entendido: no se vuelve a sugerir."); }
    catch (e) { b.disabled = false; toast("<b>No se pudo.</b> " + esc((e as Error).message)); }
  });
}
